var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageBytes && !_vm.uploading)?_c('img',{staticClass:"rounded-circle",staticStyle:{"object-fit":"cover","max-width":"100%","max-height":"100%"},attrs:{"src":'data:image/jpeg;base64,' + _vm.imageBytes}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }